/* ================================================================
   PLAFOND PANIER — assets/cart-cap.js

   Bloque le checkout du drawer au-dessus d'un montant donne.
   Ne patche NI window.fetch NI XMLHttpRequest : le total est lu
   directement dans le DOM du drawer (data-price / data-quantity),
   les memes attributs que calculateCartTotals() du theme.
   ================================================================ */
(function () {
  'use strict';

  if (window.__cartCap) { return; }
  window.__cartCap = true;

  /* ======================= CONFIG ======================= */
  var LIMITE      = 200;    // plafond, dans la devise affichee
  var DRAWER_ONLY = true;   // false = bloque aussi la page /cart
  var FORMAT_FR   = false;  // true = "212,00 EUR"  |  false = format du theme
  var DEBUG       = false;  // true = logs dans la console (F12)

  var TXT_LABEL   = 'Destockage · stocks limites';
  var TXT_WHY_A   = 'Les quantites sont limitees : nous plafonnons chaque commande a ';
  var TXT_WHY_B   = ' pour que chacun puisse en profiter.';
  var TXT_DO_A    = 'Retirez ';
  var TXT_DO_B    = ' pour valider. ';
  var TXT_DO_C    = 'Vous pourrez recommander juste apres.';
  /* ====================================================== */

  var LIMIT_CENTS = LIMITE * 100;
  var total = 0;

  function log() {
    if (!DEBUG || !window.console) { return; }
    console.log.apply(console, ['[cart-cap]'].concat(Array.prototype.slice.call(arguments)));
  }

  var CTA_SEL = '[name="checkout"],.cart__checkout,[data-cart-checkout],'
              + 'a[href$="/checkout"],a[href*="/checkout"],a[href*="/checkouts/"]';
  var EXPRESS_SEL = '.additional-checkout-buttons,[data-shopify="dynamic-checkout-cart"],'
              + '.cart__dynamic-checkout-buttons,shopify-accelerated-checkout,'
              + 'shopify-accelerated-checkout-cart,.shopify-payment-button';
  var WRAP_SEL = '.cart__checkout-wrapper,.cart__ctas,.drawer__footer';
  var DRAWER_RE = /(drawer|mini-?cart|cart-?popup|cart-?modal|off-?canvas|side-?cart|cart-?sidebar|cart-?flyout|slide-?cart)/i;

  /* ================================================================
     LECTURE DU TOTAL — 100 % DOM, aucune requete
     ================================================================ */
  function sumItems(scope) {
    var items = scope.querySelectorAll('.cart__item');
    if (!items.length) { return null; }
    var sum = 0;
    for (var i = 0; i < items.length; i++) {
      var p = parseInt(items[i].getAttribute('data-price'), 10) || 0;
      var q = parseInt(items[i].getAttribute('data-quantity'), 10) || 0;
      sum += p * q;
    }
    return sum;
  }

  function parseMoney(txt) {
    var s = String(txt || '').replace(/[^\d.,]/g, '');
    if (!s) { return null; }
    var i = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    var ip, dp;
    if (i > -1 && (s.length - i - 1) <= 2) {
      ip = s.slice(0, i).replace(/[.,]/g, '');
      dp = s.slice(i + 1);
    } else {
      ip = s.replace(/[.,]/g, '');
      dp = '';
    }
    var cents = (parseInt(ip || '0', 10) * 100) + parseInt((dp + '00').slice(0, 2), 10);
    return isNaN(cents) ? null : cents;
  }

  function refreshTotal() {
    var scope = document.getElementById('CartDrawer') || document;

    var s = sumItems(scope);
    if (s === null && scope !== document) { s = sumItems(document); }
    if (s !== null) { total = s; return total; }

    var sub = scope.querySelector('[data-subtotal]')
           || document.querySelector('[data-subtotal]');
    var v = sub ? parseMoney(sub.textContent) : null;
    total = (v === null) ? 0 : v;
    return total;
  }

  function over() { return total > LIMIT_CENTS; }

  /* ---------------- devise ---------------- */
  var SYMBOL = (function () {
    try {
      var c = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
      if (c === 'GBP') { return '£'; }
      if (c === 'USD') { return '$'; }
      if (c === 'EUR') { return '€'; }
    } catch (e) {}
    return '€';
  })();

  function money(cents) {
    var a = (Math.abs(cents || 0) / 100).toFixed(2);
    if (FORMAT_FR) { return a.replace('.', ',') + ' ' + SYMBOL; }
    return SYMBOL + a;
  }

  /* ---------------- portee ---------------- */
  function inDrawer(el) {
    if (el.closest && el.closest('#CartDrawer')) { return true; }
    var n = el;
    while (n && n !== document.body) {
      var cls = (typeof n.className === 'string') ? n.className : '';
      if (DRAWER_RE.test((n.tagName || '') + ' ' + (n.id || '') + ' ' + cls)) { return true; }
      n = n.parentElement;
    }
    return false;
  }
  function inScope(el) { return DRAWER_ONLY ? inDrawer(el) : true; }

  /* ---------------- styles ---------------- */
  function injectCss() {
    if (document.getElementById('cartcap-css')) { return; }
    var css = ''
      + '.cartcap{display:block!important;margin:0 0 12px!important;padding:13px 15px 14px!important;'
      + 'background:#fff!important;border:1px solid rgba(11,11,11,.38)!important;border-radius:12px!important;'
      + 'color:#0B0B0B!important;font-family:inherit;text-align:left!important;'
      + 'box-shadow:0 1px 2px rgba(11,11,11,.04);-webkit-font-smoothing:antialiased;'
      + 'animation:cartcap-in .32s cubic-bezier(.2,.7,.3,1) both}'
      + '@keyframes cartcap-in{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}'
      + '.cartcap__top{display:flex!important;align-items:center!important;justify-content:space-between!important;'
      + 'gap:12px;margin:0 0 8px 0!important}'
      + '.cartcap__label{display:flex!important;align-items:center;gap:7px;font-size:10px!important;'
      + 'line-height:1!important;font-weight:600!important;letter-spacing:.13em!important;'
      + 'text-transform:uppercase!important;color:#0B0B0B!important}'
      + '.cartcap__dot{width:6px;height:6px;border-radius:50%;background:#0B0B0B;flex:0 0 auto;'
      + 'animation:cartcap-pulse 1.7s ease-in-out infinite}'
      + '@keyframes cartcap-pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.3;transform:scale(.78)}}'
      + '.cartcap__count{font-size:11px!important;line-height:1!important;font-weight:600!important;'
      + 'letter-spacing:.02em;color:#0B0B0B!important;font-variant-numeric:tabular-nums;white-space:nowrap}'
      + '.cartcap__why{margin:0 0 5px 0!important;font-size:12px!important;line-height:1.45!important;'
      + 'color:rgba(11,11,11,.55)!important}'
      + '.cartcap__do{margin:0!important;font-size:12.5px!important;line-height:1.45!important;'
      + 'color:#0B0B0B!important;font-weight:500!important}'
      + '.cartcap__do b{font-weight:600}'
      + '.cartcap__do span{color:rgba(11,11,11,.55);font-weight:400}'
      + '.cartcap.is-shake{animation:cartcap-shake .38s cubic-bezier(.36,.07,.19,.97) both}'
      + '@keyframes cartcap-shake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}'
      + '30%,50%,70%{transform:translateX(-3px)}40%,60%{transform:translateX(3px)}}'
      + '.cartcap-lock{opacity:.38!important;pointer-events:none!important;filter:grayscale(1)!important}'
      + '.cartcap-lock-express{opacity:.38!important;pointer-events:none!important;filter:grayscale(1)!important}'
      + '.cartcap-wrap-locked{cursor:not-allowed}';

    var st = document.createElement('style');
    st.id = 'cartcap-css';
    st.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(st);
  }

  /* ---------------- construction DOM ---------------- */
  function mk(tag, cls) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    return n;
  }

  function build() {
    var root = mk('div', 'cartcap');
    root.setAttribute('role', 'status');
    root.setAttribute('aria-live', 'polite');

    var top = mk('div', 'cartcap__top');
    var label = mk('span', 'cartcap__label');
    label.appendChild(mk('i', 'cartcap__dot'));
    label.appendChild(document.createTextNode(TXT_LABEL));
    top.appendChild(label);
    top.appendChild(mk('span', 'cartcap__count'));

    var why = mk('p', 'cartcap__why');
    why.appendChild(document.createTextNode(TXT_WHY_A + money(LIMIT_CENTS) + TXT_WHY_B));

    var doo = mk('p', 'cartcap__do');
    doo.appendChild(document.createTextNode(TXT_DO_A));
    doo.appendChild(mk('b'));
    doo.appendChild(document.createTextNode(TXT_DO_B));
    var tail = mk('span');
    tail.appendChild(document.createTextNode(TXT_DO_C));
    doo.appendChild(tail);

    root.appendChild(top);
    root.appendChild(why);
    root.appendChild(doo);
    return root;
  }

  function paint(node) {
    var c = node.querySelector('.cartcap__count');
    var want = money(total) + ' / ' + money(LIMIT_CENTS);
    if (c && c.textContent !== want) { c.textContent = want; }

    var b = node.querySelector('.cartcap__do b');
    var wantB = money(total - LIMIT_CENTS);
    if (b && b.textContent !== wantB) { b.textContent = wantB; }
  }

  /* ---------------- verrouillage ---------------- */
  function lock(btn) {
    if (btn.getAttribute('data-cc-lock') === '1') { return; }
    btn.setAttribute('data-cc-lock', '1');
    btn.classList.add('cartcap-lock');
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('tabindex', '-1');
    var w = btn.closest(WRAP_SEL);
    if (w) { w.classList.add('cartcap-wrap-locked'); }
  }

  function unlock(btn) {
    if (btn.getAttribute('data-cc-lock') !== '1') { return; }
    btn.removeAttribute('data-cc-lock');
    btn.classList.remove('cartcap-lock');
    btn.removeAttribute('aria-disabled');
    btn.removeAttribute('tabindex');
    var w = btn.closest(WRAP_SEL);
    if (w) { w.classList.remove('cartcap-wrap-locked'); }
  }

  /* ---------------- application ---------------- */
  var applying = false;

  function childCap(parent) {
    var kids = parent.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].classList && kids[i].classList.contains('cartcap')) { return kids[i]; }
    }
    return null;
  }

  function apply() {
    if (applying || !document.body) { return; }
    applying = true;

    refreshTotal();
    injectCss();

    var seen = [];
    var btns = document.querySelectorAll(CTA_SEL);

    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (!inScope(btn)) { continue; }

      if (over()) { lock(btn); } else { unlock(btn); }

      var parent = btn.parentNode;
      if (!parent || !parent.children) { continue; }

      var node = childCap(parent);

      if (over()) {
        if (!node) { node = build(); parent.insertBefore(node, btn); }
        paint(node);
        seen.push(node);
      } else if (node) {
        parent.removeChild(node);
      }
    }

    var ex = document.querySelectorAll(EXPRESS_SEL);
    for (var j = 0; j < ex.length; j++) {
      if (!inScope(ex[j])) { continue; }
      if (over()) { ex[j].classList.add('cartcap-lock-express'); }
      else { ex[j].classList.remove('cartcap-lock-express'); }
    }

    var all = document.querySelectorAll('.cartcap');
    for (var k = 0; k < all.length; k++) {
      if (seen.indexOf(all[k]) === -1 && all[k].parentNode) {
        all[k].parentNode.removeChild(all[k]);
      }
    }

    applying = false;
  }

  function flash() {
    var all = document.querySelectorAll('.cartcap');
    for (var i = 0; i < all.length; i++) {
      var n = all[i];
      n.classList.remove('is-shake');
      void n.offsetWidth;
      n.classList.add('is-shake');
      try { n.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }
  }

  /* ================================================================
     BLOCAGE — capture sur WINDOW.
     La capture traverse window avant document : cet ecouteur passe
     donc avant l'intercepteur de checkout du theme (qui ecoute sur
     document), quel que soit l'ordre de chargement des scripts.
     ================================================================ */
  window.addEventListener('click', function (e) {
    var t = (e.target && e.target.closest) ? e.target : null;
    if (!t) { return; }

    // Sortie immediate si le clic ne concerne pas une zone de paiement :
    // aucun traitement, aucun effet de bord sur le reste du site.
    var hit = t.closest(CTA_SEL) || t.closest(EXPRESS_SEL);
    var wrapOnly = hit ? null : t.closest(WRAP_SEL);
    if (!hit && !wrapOnly) { return; }

    refreshTotal();
    if (!over()) { return; }

    if (hit && inScope(hit)) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
      log('checkout bloque', money(total), '>', money(LIMIT_CENTS));
      apply();
      flash();
      return;
    }

    if (wrapOnly && wrapOnly.querySelector('.cartcap-lock')) { flash(); }
  }, true);

  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) { return; }

    refreshTotal();
    if (!over()) { return; }

    var action = f.getAttribute('action') || '';
    if (f.id !== 'CartDrawerForm' && !/\/cart|\/checkout/.test(action)) { return; }
    if (!inScope(f)) { return; }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }
    log('submit bloque');
    apply();
    flash();
  }, true);

  /* ---------------- declencheurs ---------------- */
  var EVENTS = ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build',
                'cart:open', 'drawer:open', 'ajaxCart.afterCartLoad',
                'product:added-to-cart'];
  for (var e0 = 0; e0 < EVENTS.length; e0++) {
    document.addEventListener(EVENTS[e0], function () { setTimeout(apply, 60); });
  }
  window.addEventListener('pageshow', function () { setTimeout(apply, 60); });

  /* ---------------- demarrage ---------------- */
  function boot() {
    injectCss();
    apply();
    log('actif — plafond', money(LIMIT_CENTS), '| panier', money(total));

    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var tg = muts[i].target;
        if (tg && tg.closest && tg.closest('.cartcap')) { continue; }
        clearTimeout(mo._t);
        mo._t = setTimeout(apply, 120);
        return;
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
